<template>
  <div class="home_wrap">
    <Header></Header>
    <van-row style="padding-top: 15px">
      <van-col span="24" class="topSection">
        <router-link to="/index">
          <img src="../images/common/backArrow.png" class="imageleft" />
        </router-link>
        <span style="color: #ffffff; font-size: 26px">{{ $t("about.about") }}</span>
      </van-col>
    </van-row>
    <van-row style="padding-top: 25px">
      <div class="guideBody">
        <!-- <p style="color: #ffffff; font-size: 26px; text-align: center">
          FIRST LEVEL TITLE
        </p> -->
        <p class="content">
          The American Film Market is the most efficient film acquisition,
          development and networking event in the world. Unlike a festival, AFM
          is a marketplace where production and distribution deals are closed.
          More than US$1 billion in deals are sealed every year — on both
          completed films and those in every stage of development and
          production.
        </p>
        <p class="content">
          1000’s of industry professionals from more than 80 countries converge
          in Santa Monica every November. They include acquisition and
          development executives, agents, attorneys, directors, distributors,
          festival directors, financiers, film commissioners, producers,
          writers, the world’s press and all those who provide services to the
          motion picture industry.
        </p>
        <p class="content">
          At AFM, participants can discover the entire global catalogue of
          available films and projects, attend 30+ world class conferences and
          panels, and connect with the independent film community’s decision
          makers, all in one convenient location without the distraction of a
          film festival.
        </p>
      </div>
    </van-row>
  </div>
</template>

<script>
import Vue from "vue";
import Header from "../../components/header";
import { Icon, Col, Row } from "vant";
Vue.use(Icon).use(Row).use(Col);

export default {
  name: "about",
  components: {
    Header,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.home_wrap {
  width: 100%;
  min-height: 100vh;
  background: url("../images/common/detailed_screen.png");
  background-size: 100% 100%;
}

.topSection {
  // align-items: center;
  display: flex;
  justify-content: center;
}

.imageleft {
  height: 28px;
  width: auto;
  position: absolute;
  left: 8px;
}

.guideBody {
  padding: 10px;
  border: 2px solid #ffffff;
  border-radius: 15px;
  margin: 0px 15px 15px;
  background: #ebebeb29;
}

.content {
  color: #ffffff;
  font-size: 16px;
  text-align: justify;
  padding: 20px 0px;
  word-break: break-word;
}
</style>
